<template>
  <div>
    <div v-if="show == 0" style="font-size: 40px">暂无注册公司</div>
    <el-card v-if="show == 1">
      <template #header>
        <span>公司信息</span>
      </template>

      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="first">
          <BasicInformation :companyId="companyApplyId"></BasicInformation>
        </el-tab-pane>
        <el-tab-pane label="公司用户" name="second">
          <MemberManage :companyId="companyApplyId" ></MemberManage>
        </el-tab-pane>
        <el-tab-pane label="产品购买" name="third">
          <CompanyBuy :companyId="companyApplyId"></CompanyBuy>
        </el-tab-pane>
        <el-tab-pane label="公司订单" name="forth">
          <CompanyOrderList :companyId="companyApplyId"></CompanyOrderList>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-card v-if="show == 2">
      <template #header>
        <span>公司信息</span>
      </template>
      <div style="margin: 10px 15px 10px 15px;">
        <el-table :data="itemCompanyList" style="width: 100%;text-align: center; height: 100%; " border
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="id" label="公司id" width="80" show-overflow-tooltip align="center"/>
          <el-table-column prop="companyName" label="公司名称" min-width="180" show-overflow-tooltip align="center"/>
          <el-table-column prop="createTime" label="创建时间" min-width="180" show-overflow-tooltip align="center"/>
          <el-table-column label="详情" width="250" align="center">
            <template slot-scope="scope">
              <el-button style="height:50px;width: 150px" type="warning" :plain="true" @click="showDetail(scope.row)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import BasicInformation from "@/pages/userCenter/ChildComps/BasicInformation";
import CompanyBuy from "@/pages/userCenter/ChildComps/CompanyBuy";
import CompanyOrderList from "@/pages/userCenter/ChildComps/CompanyOrderList";
import MemberManage from "@/pages/userCenter/ChildComps/MemberManage";
import API from "../../../../../config/api";

export default {
  data() {
    return {
      activeName: 'first',//tab选中的
      itemCompanyList: [],//已通过的注册公司
      show: null,
      companyApplyId:0, //选中展示公司信息的id
    }
  },
  components: {
    BasicInformation,
    MemberManage,
    CompanyBuy,
    CompanyOrderList
  },
  mounted() {
    this.show =null;
    this.getCompanyList();
    this.companyApplyId = null;
  },
  methods: {
    //页面切换
    handleClick(tab) {
      console.log(tab);
      this.activeName = tab.name;
    },
    //查看详情
    showDetail(item){
      this.companyApplyId = item.id;
      this.show = 1;
    },
    //获取公司列表
    getCompanyList() {  //获取已注册公司信息
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {}
      this.$axiosRequest({
        url: API.getCompanyList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.itemCompanyList = res.data["companyList"];
          if (this.itemCompanyList.length == 0) {
            this.show = 0;
          } else if (this.itemCompanyList.length == 1) {
            this.show = 1;
            this.companyApplyId = this.itemCompanyList[0].id;
          } else if (this.itemCompanyList.length > 1) {
            this.show = 2;
          }
        }
      });
    },


  }
}
</script>

<style scoped>

</style>